<template>
    <div>
        <span v-if="!isEditMode">{{contacts[name]}}</span>

        <div v-if="isEditMode" :class="{'has-error': !isValid}">
            <div class="group">
                <div :class="{'column inputColumn full': true, 'error': !isValid}">
                    <input :name="name" class="usual-label" v-model="contacts[name]" :type="type" />
                    <label :ph="label" :fl="label"></label>
                </div>
            </div>

            <slot></slot>
        </div>
    </div>
</template>

<script>
    import {requiredString, requiredObject, requiredBool} from '../../utils/prop-types';

    export default {
        props: {
            name: requiredString,
            label: requiredString,
            contacts: requiredObject,
            isEditMode: requiredBool,
            isValid: requiredBool,
            type: { type: String },
        },
    }
</script>

<style lang="scss" scoped>
    .has-error {
        margin-bottom: 10px;
    }
</style>
